export default __webpack_public_path__ + "static/media/confirm_dispatch.1ebdb0c8.svg";